<template lang="pug">
  .spotplan.grid-content
    el-row(:gutter="20")
      el-col.text-right(:span="4") {{ $t('Sub SOW') }}
      el-col(:span="4") {{ data.sub_final_scope_name }}
    el-row(:gutter="20")
      el-col.text-right(:span="4") {{ $t('供应商') }}
      el-col(:span="4") {{ data.vendor_name }}
    Category(:data="data.category_scope")
    template(v-for="item, index in data.contracts")
      contract-and-do-item(:item="item" :index="index")
    el-row(:gutter="20")
      el-col.text-right.required(:span="4") Spotplan
      el-col.spotplan__flex-col(:span="20")
        a(
          v-if="isView"
          :herf="data.sub_final_scope_vendor.download_url"
          target="_blank"
        ) {{ data.sub_final_scope_vendor.file_name }}
        template(v-else)
          el-upload(
            :action="$t('组件必传项，无意义')"
            :http-request="upload"
            :show-file-list="false"
          )
            el-button(
              type="primary",
            ) {{ $t('点击上传') }}
          span {{ fileName }}
</template>

<script>
import Category from '@/components/Category'
import UploadFile from '@/components/UploadFile'
import ContractAndDoItem from '@/components/ContractAndDoItem'
export default {
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    Category,
    UploadFile,
    ContractAndDoItem
  },
  data () {
    return {
      fileName: ''
    }
  },
  computed: {
    isView () {
      return this.$route.query.status === 'completed'
    }
  },
  methods: {
    upload (inst) {
      this.fileName = inst.file.name
      this.$emit('upload', inst.file)
    }
  }
}
</script>

<style lang="stylus" scoped>
.spotplan__flex-col
  display flex
  align-items center
  > span
    margin-left 10px
</style>
